export class Action {
    constructor() {
    }
    _id: string;
    value: string;
    action_name: string;
    action_display_name: string;
    action_description: string;
    display_order:number;
    section_action_tags: Array<string>;
    supporting_actions: Array<string>;
    //copy object properties
    public map(source: Action): void {
        Object.keys(source).map((key, index) => {
            this[key] = source[key];
        });
    }
}

